{
  "search": "Buscar",
  "tabs": {
    "users": "Usuarios",
    "roles": "Roles",
    "roleProfiles": "Perfiles de roles",
    "organizations": "Organizaciones",
    "clientReportTemplates": "Plantilla de informe del cliente",
    "featureFlags": "Indicadores de características",
    "workflows": "Flujos de trabajo",
    "downtimeSchedule": "Calendario de inactividad",
    "pageConfigurations": "Configuraciones de página",
    "staticPageWidgetConfigurations": "Configuraciones del widget de página estática",
    "htmlTemplates": "Plantillas HTML editables",
    "notificationGroups": "Grupos de notificaciones",
    "notificationDefinitions": "Definiciones de las notificaciones",
    "customFields": "Campos personalizables",
    "localizationSettings": "Configuración de localización",
    "repCodes": "Códigos de representante",
    "dashboards": "Paneles de control",
    "documentManagement": "Gestión de documentos"
  },
  "userTable": {
    "name": "Nombre",
    "email": "Correo electrónico",
    "role": "Rol",
    "displayRole": "Rol de Visualización",
    "displayRoleFilterAll": "Todos los roles de visualización",
    "noResults": "Ningún usuario coincide con sus filtros",
    "accessType": "Tipo de acceso",
    "organization": "Organización",
    "status": {
      "header": "Último inicio de sesión el",
      "LOGGED_IN": "Sesión iniciada",
      "NOT_LOGGED_IN": "Sesión sin iniciar",
      "INVITED": "Invitado",
      "INVITATION_EXPIRED": "Invitación expirada",
      "NOT_INVITED": "Sin invitar"
    },
    "inviteUsersButton": "Invitar usuarios",
    "userSearch": "Buscar",
    "roleFilterAll": "Todos los roles"
  },
  "userEntityTable": {
    "title": "Entidades vinculadas",
    "name": "Nombre",
    "relation": "Relación",
    "entityType": "Tipo de entidad"
  },
  "userRepCodeEntityTable": {
    "title": "Entidades vinculadas (códigos de representantes)",
    "name": "Nombre",
    "repCodes": "Códigos de representante"
  },
  "roleTable": {
    "name": "Nombre",
    "navigationStyle": "Estilo de navegación",
    "noPermissions": "# de permisos",
    "organization": "Organización"
  },
  "roleProfilesTable": {
    "name": "Nombre",
    "organization": "Organización",
    "inherited": "Heredado"
  },
  "organizationTable": {
    "name": "Nombre",
    "subdomain": "Subdominio",
    "parent": "Padre/Madre",
    "countriesJurisdictions": "Países/Jurisdicciones"
  },
  "workflowStates": {
    "DRAFT": "Borrador",
    "ACTIVE": "Activo",
    "ARCHIVED": "Archivado"
  },
  "workflowTransitions": {
    "activate": "Establecer flujo de trabajo como Activo",
    "draft": "Establecer flujo de trabajo como Borrador",
    "archive": "Establecer flujo de trabajo como Archivado"
  },
  "workflowTransitionSuccess": "Cambió el estado del flujo de trabajo",
  "workflowTable": {
    "name": "Nombre",
    "state": "Estado",
    "numberOfSteps": "# de pasos",
    "organization": "Organización"
  },
  "workflowModal": {
    "title": "Crear flujo de trabajo nuevo",
    "name": "Nombre"
  },
  "userModal": {
    "editTitle": "Actualizar usuario",
    "title": "Crear nuevo usuario",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "email": "Correo electrónico (para iniciar sesión)",
    "language": "Idioma",
    "languageList": {
      "ENGLISH": "Inglés",
      "FRENCH": "Francés"
    },
    "phoneUsedForLogin": "Teléfono (para iniciar sesión)",
    "phone": "Teléfono",
    "role": "Rol",
    "avatar": "Avatar",
    "organization": "Organización",
    "accessType": "Tipo de acceso",
    "resetMfa": "Restablecer la autenticación de múltiples factores",
    "autoInviteUser": "Invitar automáticamente al usuario",
    "inviteUser": "Invitar usuario",
    "resendInvitation": "Reenviar invitación",
    "revokeInvitation": "Suspender invitación",
    "repCodes": "Códigos de representante",
    "repCodesNone": "Sin códigos de representante",
    "viewFullClientGroup": "Ver grupo de clientes completo",
    "displayRole": "Rol de Visualización",
    "displayRoleNone": "Ninguno"
  },
  "accessUsers": {
    "title": "Acceso de usuarios",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "email": "Correo electrónico",
    "loginStatus": "Estado del inicio de sesión",
    "lastLoginAt": "Último inicio de sesión el",
    "organization": "Organización"
  },
  "userDeleteModal": {
    "deleteUser": "Eliminar usuario",
    "deletedCompletely": "El usuario será eliminado por completo de OneHub. No podrá volver a iniciar sesión.",
    "wantToProceed": "¿Desea continuar?",
    "yesDelete": "Sí, eliminar"
  },
  "userRevokeInvitationModal": {
    "title": "Suspender invitación de usuario",
    "body": "La invitación existente se suspenderá. Podrá invitar al usuario de nuevo. ¿Desea continuar?"
  },
  "userResetMultifactorModal": {
    "title": "Restablecer múltiples factores del usuario",
    "body": "El usuario deberá registrarse en la autenticación de múltiples factores la próxima vez que inicie sesión. ¿Desea continuar?"
  },
  "inviteSingleUserConfirmationModal": {
    "title": "Invitar usuario",
    "body": "{{name}} recibirá la invitación en este correo electrónico: ({{email}}). ¿Desea continuar?"
  },
  "inviteUsersConfirmationModal": {
    "title": "Invitar usuarios pendientes",
    "body": "Un total de {{total}} usuario(s) recibirán una invitación en su correo electrónico. ¿Desea continuar?"
  },
  "emailUpdateConfirmation": {
    "title": "Actualizar autenticación de usuario",
    "body": "El usuario deberá utilizar el nuevo correo electrónico la próxima vez que inicie sesión ({{email}}). ¿Desea continuar?"
  },
  "roleModal": {
    "editTitle": "Actualizar rol",
    "title": "Crear rol nuevo",
    "name": "Nombre",
    "description": "Descripción",
    "organization": "Organización",
    "roleProfile": "Perfil de función",
    "permissions": "Permisos",
    "accessiblePages": "Páginas",
    "dashboards": "Paneles de control",
    "configurableTablePages": "Páginas de tabla configurables",
    "externalRoleId": "Id. de rol externo",
    "defaultAccessType": "Tipo de acceso predeterminado",
    "nonIndividualPageConfiguration": "Configuración de página no individual",
    "individualPageConfiguration": "Configuración de página individual",
    "goalPageConfiguration": "Configuración de la página de metas",
    "accountPageConfiguration": "Configuración de la página de la cuenta",
    "accountGroupPageConfiguration": "Configuración de la página del grupo de cuentas",
    "householdPageConfiguration": "Configuración de la página del hogar",
    "homePageConfiguration": "Configuración de la página de inicio",
    "makeHouseholdDefaultView": "Establecer como vista predeterminada del hogar",
    "subAccountPageConfiguration": "Configuración de la página de subcuentas",
    "individualTableStaticPageWidgetConfiguration": "Configuración del widget de página estática de tabla individual",
    "nonIndividualTableStaticPageWidgetConfiguration": "Configuración del widget de página estática de tabla no individual",
    "householdTableStaticPageWidgetConfiguration": "Configuración del widget de página estática de la tabla del hogar",
    "accountGroupTableStaticPageWidgetConfiguration": "Configuración del widget de página estática de la tabla de grupos de cuentas",
    "permissionsTable": {
      "read": "leer",
      "write": "escribir",
      "transition": "transición"
    },
    "formTemplateWarning": "Esto solo se debe conceder a usuarios internos",
    "undefinedDefaultAuthenticationConnection": "Utilizar el valor predeterminado de la organización"
  },
  "roleProfileModal": {
    "editTitle": "Actualizar perfil del rol",
    "title": "Crear nuevo perfil para un rol",
    "name": "Nombre",
    "description": "Descripción",
    "organization": "Organización",
    "permissions": "Permisos predeterminados",
    "setAllPermitions": "Establecer todos los permisos",
    "accessiblePages": "Páginas",
    "dashboards": "Paneles de control",
    "configurableTablePages": "Páginas de tabla configurables",
    "permissionsTable": {
      "read": "leer",
      "write": "escribir",
      "transition": "transición"
    }
  },
  "roleProfileConfirmationModal": {
    "title": "¿Confirma que desea actualizar el perfil del rol?",
    "body": "Realizó cambios en el perfil de un rol. ¿Desea confirmar estos cambios?",
    "checkbox": "Actualice los roles relacionados con estos cambios. Esto anulará todos los cambios realizados en {{roles}} roles."
  },
  "roleDeleteModal": {
    "deleteRole": "Eliminar rol",
    "deletedCompletely": "El rol se eliminará por completo de OneHub.",
    "wantToProceed": "¿Desea continuar?",
    "yesDelete": "Sí, eliminar el rol"
  },
  "roleProfileArchiveModal": {
    "archiveRoleProfile": "Archivar el perfil del rol",
    "archiveConfirmation": "El perfil del rol se archivará y ya no estará disponible en OneHub.",
    "wantToProceed": "¿Desea continuar?",
    "yesArchive": "Sí, archivar el perfil del rol"
  },
  "newOrganizationModal": {
    "title": "Crear nueva organización"
  },
  "dashboardsTable": {
    "name": "Nombre",
    "organization": "Organización",
    "state": "Estado",
    "archive": "Archivar",
    "modelName": "Panel de control",
    "widgets": "Componentes"
  },
  "organizationDetails": {
    "saveChanges": "Guardar cambios",
    "basics": "Básicos",
    "inheritance": "Herencia",
    "name": "Nombre",
    "entityName": "Nombre de la entidad",
    "entityNameHelperText": "El nombre que aparece en la documentación oficial, como los formularios de designación de beneficiarios",
    "subdomain": "Subdominio",
    "faviconLink": "Enlace al favicon",
    "browserTabTitle": "Título de la pestaña del navegador",
    "parent": "Padre/Madre",
    "useParentFormTemplates": "Utilizar plantillas de formularios del padre",
    "useParentProductShelf": "Utilizar estante de productos del padre",
    "useParentModelPortfolios": "Utilizar carteras modelo del padre",
    "useParentAssetClasses": "Utilizar clases de activos del padre",
    "useParentThemes": "Utilizar temas del padre",
    "useParentSchedules": "Utilizar horarios del padre",
    "useParentFeeTiers": "Utilizar tabla de tarifas del padre",
    "useParentWorkflows": "Utilizar flujos de trabajo del padre",
    "useParentRoleProfiles": "Utilizar perfiles de roles del padre",
    "useParentPageConfigurations": "Utilizar configuraciones de página del padre",
    "useParentStaticPageWidgetConfigurations": "Utilizar configuraciones del widget de página estática del padre",
    "useParentCustodianConnections": "Utilizar conexiones de custodios del padre",
    "useParentCustomFields": "Utilizar campos personalizables del padre",
    "useParentBillingSchedules": "Utilizar calendarios de facturación del padre",
    "useParentIntegrations": "Utilizar integraciones del padre",
    "useParentWebhooks": "Utilizar webhooks del padre",
    "useParentLocalizations": "Utilizar localizaciones del padre",
    "useParentThemeTokens": "Utilizar tokens temáticos del padre",
    "useParentArticles": "Utilizar noticias y artículos de opinión del padre",
    "reviewTransactions": "Revisar transacciones",
    "allowInstantInvest": "Permitir inversión instantánea",
    "logo": "URL del logotipo",
    "topBarColor": "Color de la barra superior",
    "topBarTextColor": "Color del texto de la barra superior",
    "primaryColor": "Color principal",
    "pageBackgroundColor": "Color de fondo de la página",
    "allowInactiveUserRebalancing": "Permitir el reequilibrio de usuarios inactivos",
    "allowInactiveUserFeeCalculation": "Permitir el cálculo de la tarifa de usuario inactivo",
    "allowInactiveUserAdjustments": "Habilitar ajustes en usuarios congelados",
    "allowLogout": "Permitir cerrar sesión",
    "logoutRedirectUrl": "URL de redireccionamiento al cerrar sesión",
    "customRedirectUrlHelperText": "Antes de actualizar este campo, asegúrese de haberlo actualizado en auth0",
    "enableInactivityTimeOut": "Habilitar tiempo de espera por inactividad",
    "inactivityTimeoutInMinutes": "Tiempo de inactividad en minutos",
    "allowPortfolioPerGoal": "Permitir configurar la cartera por objetivo",
    "requireManualAccountApproval": "Aprobación manual de cuentas",
    "requireSubTradeRequestApproval": "Se requiere verificación comercial",
    "allowViewSubTradeRequestPairs": "Permitir ver pares de solicitudes de subcomercio",
    "allowPendingTransactions": "Incluir transacciones pendientes dentro de las tenencias",
    "chargeAdminFeesToClient": "Cobrar tarifas administrativas al cliente",
    "uploadLogo": "Cargar logo",
    "uploadErrorPageBackgroundImage": "Cargar fondo de la página de error",
    "displayNavbar": "Mostrar barra de navegación",
    "theme": "Tema",
    "accountTypeTaxRanking": "Tipo de cuenta en clasificación fiscal",
    "supportUrl": "URL de soporte",
    "helpCentreUrl": "URL del Centro de ayuda",
    "termsAndConditionsUrl": "URL de los Términos y condiciones",
    "customUrl": "Personalizar URL",
    "customUrlHelperText": "Antes de actualizar este campo, asegúrese de que el equipo de CloudOps haya configurado el CNAME",
    "urlError": "URL inválida",
    "colorError": "Código hexadecimal de color no válido",
    "logoUrlError": "Solo se aceptan archivos PNG para el logotipo.",
    "requireFeeApproval": "Aprobación manual de tarifas",
    "hideAutoUpdatePrices": "Ocultar precios de actualización automática",
    "minimumInitialDeposit": "Depósito inicial mínimo",
    "minimumInitialDeposit1Dollar": "El depósito inicial mínimo es de $1.00",
    "defaultTradingProcess": "Proceso comercial predeterminado por subcuenta",
    "bulkTradingProcess": "Proceso predeterminado de negociación masiva",
    "blockSuspiciousTransactions": "Bloquear transacciones sospechosas",
    "cashOnHoldToTradeDays": "Tiempo de retención para transacción",
    "cashOnHoldToWithdrawDays": "Tiempo de espera para el retiro",
    "cancelTransferCutoffDays": "Días antes de una transferencia en los que ya no se puede cancelar la transferencia",
    "holdTimeRange": "El tiempo de retención debe tener un rango de entre 0 y 365 días",
    "defaultSignUpRole": "Rol predeterminado al registrarse",
    "defaultAdvisorRole": "Rol predeterminado del asesor",
    "defaultClientRole": "Rol predeterminado del cliente",
    "authenticationTitle": "Opciones de autenticación",
    "disableStatsUpdateBasedOnTransactions": "Desactivar la actualización de estadísticas basada en transacciones",
    "disableRebalanceReport": "Desactivar el cálculo del informe de reequilibrio",
    "minRecurringDepositCents": "Depósito mínimo programado (único, recurrente)",
    "minRecurringDepositError": "El importe es inferior al depósito mínimo recurrente aceptable.",
    "profileReviewTimeInMonths": "Tiempo de revisión del perfil en meses",
    "profileReviewTimeInMonthsError": "El tiempo de revisión del perfil en meses debe ser superior a 0",
    "authenticationTheme": {
      "logo": "URL del logotipo (flujo de autenticación)",
      "primaryColor": "Color principal (flujo de autenticación)",
      "pageBackgroundColor": "Color de fondo de la página (flujo de autenticación)"
    },
    "auth0DisplayName": "Nombre mostrado (flujo de autenticación)",
    "enableMultiFactorAuthentication": "Habilitar la autenticación de múltiples factores",
    "multiFactorAuthenticationTitle": "Opciones de autenticación de múltiples factores",
    "multiFactorAuthenticationOptions": {
      "EMAIL": "Correo electrónico",
      "SMS": "Mensaje SMS",
      "AUTHENTICATOR": "Autenticador"
    },
    "enableRemeberBrowser": "Habilitar Recordar navegador",
    "enableEmailFrenchTranslation": "Habilitar traducción al francés por correo electrónico",
    "defaultAuthenticationConnectionTitle": "Tipo de autenticación",
    "defaultAuthenticationConnectionOptions": {
      "EMAIL_AND_PASSWORD": "Correo electrónico y contraseña",
      "EMAIL_OTP": "Correo electrónico: código de un solo uso (sin contraseña)",
      "ENTERPRISE": "SSO empresarial"
    },
    "allowAccessToSubOrganizations": "Permitir el acceso a suborganizaciones",
    "authenticationDomainsTable": "Dominios de autenticación",
    "authenticationDomain": {
      "url": "URL",
      "authenticationType": "Tipo",
      "enterpriseConnectionName": "Nombre de la conexión",
      "useHostedLogin": "Inicio de sesión alojado",
      "editTitle": "Actualizar dominio de autenticación",
      "addTitle": "Añadir dominio de autenticación",
      "removeDomain": "Eliminar dominio",
      "urlAlreadyExistsError": "La URL ya existe para esta organización",
      "logoutUrl": "URL para cerrar sesión"
    },
    "repCode": "Código de representante",
    "displayMenuBar": "Mostrar barra de menús cuando está incrustado",
    "displayCurrency": "Mostrar moneda",
    "allowPostOptimizationEditing": "Permitir la edición posterior a la optimización de las solicitudes de subcontratación iniciadas",
    "autoInviteImportedUsers": "Invitar automáticamente a los usuarios importados",
    "localization": "Localización",
    "noLocalization": "ninguno (se aplican los valores predeterminados)",
    "country": "país",
    "currency": "moneda",
    "enabledJurisdictions": "Habilitar jurisdicciones",
    "jurisdictionsIn": "Jurisdicciones en {{country}}",
    "jurisdictionsHelperText": "Seleccione una o más jurisdicciones en las que opera esta organización",
    "allJurisdictions": "todas",
    "selectedJurisdictions": "seleccionada",
    "jurisdictionsDisabledMessage": "Para seleccionar jurisdicciones, primero elija una localización (arriba) que defina el país o países",
    "taxIdDetails": "Datos de identificación fiscal",
    "clientType": "Tipo de cliente",
    "formatting": "Formato",
    "notImplemented": "Sin implementar",
    "minAmountDeposit": "Depósito mínimo",
    "minAmountDepositError": "El importe es inferior al depósito mínimo aceptable.",
    "errorPage": "Página de error",
    "errorMessage": "Mensaje de error",
    "errorDescription": "Descripción del error",
    "errorButtonText": "Texto del botón",
    "productShelfCurrencies": "Monedas admitidas en el Estante de productos",
    "enableContactSupport": "Habilitar soporte técnico",
    "enableResourcesAndArticles": "Habilitar recursos y artículos",
    "enableFullCashTransfers": "Habilitar transferencias de efectivo totales",
    "enablePartialCashTransfers": "Habilitar transferencias de efectivo parciales",
    "enableAllInKindTransfers": "Habilitar todo tipo de transferencias",
    "baseCurrency": "Moneda base",
    "transferTitle": "Transferencias"
  },
  "featureFlags": {
    "groups": {
      "ACCOUNT_TYPES": "Tipos de cuentas",
      "ACCOUNT_TYPES_USA": "Tipos de cuenta en EE. UU.",
      "ACCOUNT_TYPES_UK": "Tipos de cuenta en Reino Unido",
      "TRADING": "Transacción",
      "TRANSFERS": "Transferencias",
      "ACCOUNT_MANAGEMENT": "Gestión de la cuenta",
      "PROFILE": "Perfil",
      "DOCUMENTS_AND_STATEMENTS": "Documentos y estados de cuenta",
      "TEMPORARY_FLAGS": "Marcadores temporales"
    },
    "table": {
      "featureFlags": "Indicadores de características",
      "status": "Estado",
      "orgSettings": "Configuración de la organización"
    },
    "status": {
      "enabled": "Habilitado",
      "disabled": "Deshabilitado"
    },
    "settings": {
      "on": "ACTIVADO",
      "off": "DESACTIVADO",
      "undefined": "HEREDADO"
    },
    "saveButton": "Actualizar",
    "updatedToastMessage": "Se actualizaron los indicadores de características.",
    "tooltip": {
      "status": "Estado general teniendo en cuenta la configuración heredada.",
      "orgSettings": "Configuración definida para esta organización.\nHEREDADO: la organización principal más cercana con un valor específico (ACTIVADO o DESACTIVADO) definirá el estado del indicador de función."
    }
  },
  "deleteLogoModal": {
    "title": "Eliminar logo",
    "subtitle": "¿Confirma que desea eliminar este logotipo de su panel de control?",
    "yesDelete": "Sí, eliminar",
    "cancel": "Cancelar"
  },
  "deleteErrorPageImageModal": {
    "title": "Eliminar imagen de fondo",
    "subtitle": "¿Confirma que desea eliminar esta imagen de su panel de control?",
    "yesDelete": "Sí, eliminar",
    "cancel": "Cancelar"
  },
  "editableTemplate": {
    "title": "Plantillas HTML editables",
    "templateName": "Nombre de la plantilla",
    "placeholder": "Ingresa el nombre de la plantilla aquí",
    "saveTemplate": "Guardar plantilla HTML"
  },
  "pageConfigurationTable": {
    "name": "Nombre",
    "type": "Tipo",
    "organization": "Organización"
  },
  "staticPageWidgetConfigurationTable": {
    "add": "Añadir",
    "name": "Nombre",
    "widgetType": "Tipo de widget",
    "organization": "Organización"
  },
  "customFieldTable": {
    "fieldLabel": "Etiqueta de campo",
    "additionalInformation": "Información adicional",
    "inputFormat": "Formato de entrada",
    "assiciateTo": "Objeto asociado con",
    "tranlatable": "Traducible",
    "organization": "Organización",
    "key": "Clave"
  },
  "repCodeTable": {
    "code": "Código",
    "name": "Nombre",
    "organization": "Organización",
    "inherited": "Heredado",
    "assignedUsers": "Usuarios asignados",
    "noAssignedUsers": "Sin usuarios asignados",
    "notDesignated": "No designado",
    "designatedAdvisorContacts": "Contactos de Asesor Designado"
  },
  "repCodeModal": {
    "title": "Crear código de representante",
    "editTitle": "Editar código de representante",
    "archiveTitle": "¿Desea archivar este código de representante?",
    "archiveBody": "El código de representante se eliminará por completo. ¿Confirma que quiere proceder?",
    "code": "Código",
    "codeHelp": "Debe incluir mayúsculas, números y guiones bajos",
    "name": "Nombre",
    "modelName": "código de representante"
  },
  "pageConfigurationModal": {
    "title": "Crear nueva configuración de página",
    "name": "Nombre",
    "type": "Tipo",
    "types": {
      "INDIVIDUAL": "Individual",
      "NON_INDIVIDUAL": "No individual",
      "ACCOUNT": "Cuenta",
      "GOAL": "Meta",
      "SUB_ACCOUNT": "Subcuenta",
      "HOUSEHOLD": "Hogar",
      "ACCOUNT_GROUP": "Grupo de cuentas"
    }
  },
  "staticPageWidgetConfigurationModal": {
    "title": "Crear nueva configuración de widget de página estática",
    "name": "Nombre",
    "type": "Tipo",
    "create": "Crear",
    "types": {
      "INDIVIDUAL_TABLE": "Tabla individual",
      "NON_INDIVIDUAL_TABLE": "Tabla no individual",
      "HOUSEHOLD_TABLE": "Tabla del hogar",
      "ACCOUNT_GROUP_TABLE": "Tabla del grupo de cuentas"
    }
  },
  "editCustomFieldDialog": {
    "title": "¿Desea archivar el campo personalizado?",
    "body": "El campo personalizado se eliminará por completo. ¿Desea continuar?"
  },
  "customFieldModal": {
    "title": "Crear nuevo campo personalizado",
    "enableConditionalRules": "Añadir reglas condicionales",
    "editTitle": "Editar campo personalizado",
    "keyHelp": "Debe consistir únicamente en letras minúsculas, números y guiones bajos.",
    "nameHelp": "No se permiten estos caracteres: < > \\ | ^ * ` ~",
    "descriptionHelp": "No se permiten estos caracteres: < > \\ | ^ * ` ~",
    "selectOptionsHelp": "No se permiten estos caracteres: < > \\ | ^ * ` ~",
    "keyPlaceholder": "boolean_field_10001",
    "key": "Clave",
    "type": "Tipo",
    "format": "Formato",
    "displayText": "Texto mostrado",
    "value": "Agregar opciones de sección (separar cada opción con un salto de línea)",
    "descriptionMsg": "El texto anterior aparecerá en una ventana modal cuando el usuario haga clic ",
    "formats": {
      "CHECKBOX": "Casilla",
      "CURRENCY": "Moneda",
      "DATE": "Fecha",
      "DATE_TIME": "Fecha y hora",
      "DROPDOWN_LIST": "Lista desplegable",
      "EMAIL": "Correo electrónico",
      "NUMBER": "Número",
      "PHONE": "Teléfono",
      "PHYSICAL_ADDRESS": "Dirección física",
      "CUSTOM_AGREEMENTS": "Acuerdos personalizados",
      "BANK_ACCOUNT": "Cuenta bancaria",
      "RADIO_BUTTON": "Botón de opción",
      "SEARCH_LIST": "Buscar en la lista",
      "SIMPLE_TEXT": "Texto simple",
      "TEXT_AREA": "Área del texto",
      "TOGGLE_SWITCH": "Botón para activar y desactivar",
      "CUSTOM": "Personalizado"
    },
    "types": {
      "BOOLEAN": "Booleano",
      "CUSTOM_OBJECT": "Objeto personalizado",
      "DATE": "Fecha",
      "DECIMAL": "Decimal",
      "INTEGER": "Número entero",
      "MULTIPLE_SELECT": "Selección múltiple",
      "SINGLE_SELECT": "Selección única",
      "TEXT": "Texto"
    },
    "objectType": "Objeto asociado con",
    "objectTypes": {
      "ACCOUNT": "Cuenta",
      "ENTITY": "Entidad",
      "GOAL": "Meta",
      "HOUSEHOLD": "Hogar",
      "SUB_ACCOUNT": "Subcuenta",
      "TRANSACTION": "Transacción",
      "HOLDING": "Activo",
      "ACCOUNT_GROUP": "Grupo de cuentas"
    },
    "translatedDescription": "Información adicional",
    "translatedName": "Etiqueta de campo",
    "workflowStep": "Paso del flujo de trabajo",
    "workflowOptions": {
      "APPROVAL": "Aprobación",
      "DOCUMENTS": "Documentos",
      "EDIT_ACCOUNT": "Editar cuenta",
      "EDIT_GOAL": "Editar meta",
      "EMPLOYMENT_INFORMATION": "Información sobre empleo",
      "HOUSEHOLD": "Hogar",
      "NON_INDIVIDUAL_INFORMATION": "Información no individual",
      "PERSONAL_INFORMATION": "Información personal",
      "PERSONS_OF_INTEREST": "Personas de interés",
      "RELATIONSHIP_INFORMATION": "Información de la relación",
      "RESIDENCY_INFORMATION": "Información de residencia",
      "INCOME_ASSETS_AND_DEBTS": "Ingresos, activos y deudas"
    },
    "customFieldSource": "Fuente",
    "source": {
      "CUSTODIAN": "Custodio",
      "INTERNAL": "Onevest"
    },
    "enablePositiveNegativeSign": "Habilitar signo positivo/negativo",
    "enableAggregation": "Habilitar agregación",
    "customFormatHelp": "Comuníquese con las integraciones de OneVest para configurar una integración con formato personalizado."
  },
  "downtimeScheduleTable": {
    "add": "Añadir",
    "name": "Nombre",
    "state": "Estado",
    "status": "Estado",
    "organization": "Organización"
  },
  "downtimeScheduleState": {
    "ACTIVE": "Activo",
    "ARCHIVED": "Archivado",
    "INACTIVE": "Inactivo"
  },
  "downtimeScheduleStatus": {
    "UPCOMING": "Próximo",
    "ONGOING": "En curso",
    "COMPLETED": "Completado"
  },
  "downtimeSchedulePlatform": {
    "ANDROID": "Android",
    "IOS": "IOS",
    "WEB": "Web"
  },
  "downtimeScheduleModal": {
    "title": "Administrar el calendario de tiempo de inactividad",
    "name": "Nombre",
    "note": "Nota",
    "platforms": "Platformas",
    "startTime": "Hora de inicio",
    "endTime": "Hora de finalización",
    "excludeRoles": "Excluir roles",
    "helpLink": "Enlace de ayuda",
    "state": "Estado",
    "organization": "Organización",
    "downtimeScheduleDescription": "Descripción",
    "downtimeScheduleTitle": "Título",
    "create": "Crear",
    "edit": "Actualizar",
    "futureDateError": "La hora de inicio debe ser en el futuro",
    "platformsRequired": "Se debe seleccionar al menos una plataforma"
  },
  "notificationDefinitionTable": {
    "name": "Nombre",
    "object": "Objeto",
    "notificationGroup": "Grupo de notificaciones",
    "roleProfiles": "Perfiles de roles",
    "organization": "Organización",
    "event": "Evento",
    "triggerObjectType": {
      "Account": "Cuenta",
      "Goal": "Meta",
      "SubAccount": "Subcuenta",
      "Transfer": "Transferencia",
      "User": "Usuario",
      "ScheduledTransfer": "Transferencia programada",
      "AccountStatement": "Estado de cuenta"
    },
    "triggerEventType": {
      "RECONCILED": "Reconciliado",
      "CREATED": "Creado",
      "CHECK_ACCOUNT_MARKET_VALUE": "Verificar el valor de mercado de la cuenta",
      "AWAITING_REVIEW": "En espera de revisión",
      "SIGNED": "Firmado",
      "RESIGNED": "Firmado nuevamente",
      "CANCELED": "Cancelado",
      "COMPLETED": "Completado",
      "REQUESTED": "Solicitado",
      "REVIEWING": "Revisando",
      "PROCESSING": "Procesando",
      "INITIATED": "Iniciado",
      "READY": "Listo",
      "FAILED": "Falló",
      "PERSONAL_ACCOUNT_INFORMATION_UPDATED": "Información de la cuenta personal actualizada",
      "FROZEN": "Congelado",
      "PERSONAL_INFORMATION_UPDATED": "Información personal actualizada",
      "LOGIN_CREDENTIALS_UPDATED": "Credenciales de inicio de sesión actualizadas",
      "USER_ID_CHECK_UPDATED": "Verificación de identificación de usuario actualizada",
      "SUITABILITY_SCORE_UPDATED": "Puntuación de idoneidad actualizada",
      "SUITABILITY_REVIEW_DUE_COMPLETE_11_MONTHS_AGO": "Revisión de idoneidad próxima a vencer",
      "SUITABILITY_REVIEW_DUE_COMPLETE_13_MONTHS_AGO": "Revisión de idoneidad pendiente",
      "SUITABILITY_REVIEW_OVERDUE": "Revisión de idoneidad vencida",
      "ACTIVE": "Activo",
      "INACTIVE": "Inactivo",
      "INVITATION_EMAIL_SENT": "Correo electrónico de invitación enviado",
      "SKIPPED": "Omitido"
    },
    "workflow": "Flujo de trabajo",
    "add": "Añadir"
  },
  "notificationDefinitionModal": {
    "title": "Administrar definición de notificación",
    "name": "Nombre",
    "notificationGroup": "Grupo de notificaciones",
    "titleTemplate": "Título de la plantilla",
    "bodyTemplate": "Cuerpo de la plantilla",
    "linkTemplate": "Enlace a la plantilla",
    "linkText": "Enlace al texto",
    "roleProfiles": "Perfiles de roles",
    "triggerObjectType": {
      "title": "Objeto desencadenante",
      "Account": "Cuenta",
      "Goal": "Meta",
      "SubAccount": "Subcuenta",
      "Transfer": "Transferencia",
      "User": "Usuario",
      "ScheduledTransfer": "Transferencia programada",
      "AccountStatement": "Estado de cuenta"
    },
    "triggerEventType": {
      "title": "Lanzar evento",
      "RECONCILED": "Reconciliado",
      "CREATED": "Creado",
      "CHECK_ACCOUNT_MARKET_VALUE": "Verificar el valor de mercado de la cuenta",
      "AWAITING_REVIEW": "En espera de revisión",
      "SIGNED": "Firmado",
      "RESIGNED": "Firmado nuevamente",
      "CANCELED": "Cancelado",
      "COMPLETED": "Completado",
      "REQUESTED": "Solicitado",
      "REVIEWING": "Revisando",
      "PROCESSING": "Procesando",
      "INITIATED": "Iniciado",
      "READY": "Listo",
      "FAILED": "Falló",
      "FROZEN": "Congelado",
      "PERSONAL_INFORMATION_UPDATED": "Información personal actualizada",
      "PERSONAL_ACCOUNT_INFORMATION_UPDATED": "Información de la cuenta personal actualizada",
      "LOGIN_CREDENTIALS_UPDATED": "Credenciales de inicio de sesión actualizadas",
      "USER_ID_CHECK_UPDATED": "Verificación de identificación de usuario actualizada",
      "SUITABILITY_SCORE_UPDATED": "Puntuación de idoneidad actualizada",
      "SUITABILITY_REVIEW_DUE_COMPLETE_11_MONTHS_AGO": "Revisión de idoneidad próxima a vencer",
      "SUITABILITY_REVIEW_DUE_COMPLETE_13_MONTHS_AGO": "Revisión de idoneidad pendiente",
      "SUITABILITY_REVIEW_OVERDUE": "Revisión de idoneidad vencida",
      "ACTIVE": "Activo",
      "INACTIVE": "Inactivo",
      "SKIPPED": "Omitido"
    },
    "create": "Crear",
    "edit": "Actualizar",
    "remove": "Eliminar"
  },
  "notificationGroupTable": {
    "name": "Nombre",
    "object": "Objeto",
    "notificationGroup": "Grupo de notificaciones",
    "organization": "Organización"
  },
  "notificationGroupModal": {
    "title": "Crear nuevo grupo de notificaciones",
    "name": "Nombre",
    "description": "Descripción",
    "remove": "Eliminar"
  },
  "editNotificationGroupModal": {
    "title": "Editar grupo de notificaciones",
    "name": "Nombre"
  },
  "notificationChannelsOptions": {
    "enableTypes": {
      "EMAIL": "Habilitar notificaciones por correo electrónico",
      "IN_APP": "Habilitar notificaciones en la app",
      "PUSH": "Habilitar notificaciones push",
      "WEBHOOK": "Habilitar notificaciones webhook"
    },
    "setDefaultState": "Establecer estado predeterminado",
    "allowEditByClient": "Permitir la edición por parte del cliente"
  },
  "clientReportTemplates": {
    "new": "Plantilla nueva",
    "frequency": "Frecuencia",
    "frequencies": {
      "WEEKLY": "Semanal",
      "MONTHLY": "Mensual",
      "QUARTERLY": "Trimestral",
      "YEARLY": "Anual",
      "ONE_TIME": "Una sola vez"
    },
    "association": "Asociación",
    "associations": {
      "USER": "Usuario",
      "ACCOUNT": "Cuenta",
      "ACCOUNT_GROUP": "Grupo de cuentas",
      "GOAL": "Meta",
      "SUB_ACCOUNT": "Subcuenta",
      "CLIENT_GROUP": "Grupo de clientes",
      "INDIVIDUAL": "Individual",
      "NON_INDIVIDUAL": "No individual"
    },
    "states": {
      "DRAFT": "Borrador",
      "ACTIVE": "Activo",
      "INACTIVE": "Inactivo"
    },
    "lastGenerationDate": "Última fecha de generación"
  },
  "localizationSettings": {
    "countries": "Países",
    "defaultCurrency": "Moneda base",
    "languages": "Idioma(s)",
    "default": "predeterminado",
    "dateFormat": "Formato de la fecha",
    "language": {
      "en": "Inglés",
      "fr": "Francés"
    },
    "deleteConfirmationModal": {
      "title": "¿Desea eliminar esta localización?",
      "confirm": "Eliminar",
      "cancel": "Cancelar"
    }
  },
  "documentManagement": {
    "name": "Nombre",
    "association": "Asociación",
    "lastUpdatedAt": "Última actualización",
    "minVersion": "Versión",
    "state": "Estado",
    "type": "Tipo",
    "view": "Ver",
    "edit": "Editar",
    "draft": "Borrador",
    "activate": "Activar",
    "archive": "Archivar",
    "editDraft": "Editar borrador",
    "history": "Historial",
    "associatedTo": "Asociado a",
    "searchByName": "Buscar por nombre",
    "ACCOUNT": "Cuenta",
    "SUB_ACCOUNT": "Subcuenta",
    "SCHEDULE_TRANSFER": "Programar transferencia",
    "USER": "Usuario",
    "GOAL": "Meta",
    "CLIENT_GROUP": "Grupo de clientes",
    "NotAssigned": "NA",
    "minVersionLable": "Versión mín.:",
    "template": "Plantilla del documento",
    "templateState": {
      "DRAFT": "Borrador",
      "ACTIVE": "Activo",
      "ARCHIVED": "Archivado"
    },
    "noTitle": "Sin título",
    "action": {
      "edit": "Editar",
      "publish": "Publicar",
      "preview": "Previsualizar",
      "draft": "Guardar borrador",
      "download": "Descargar/imprimir",
      "apply": "Aplicar"
    },
    "language": {
      "ENGLISH": "Inglés",
      "FRENCH": "Francés"
    },
    "toastMessage": {
      "success": "La plantilla del formulario se ha actualizado correctamente"
    },
    "objectType": {
      "ACCOUNT": "cuenta",
      "SUB_ACCOUNT": "subcuenta",
      "SCHEDULE_TRANSFER": "programar transferencia",
      "USER": "usuario",
      "GOAL": "meta",
      "CLIENT_GROUP": "grupo de clientes"
    },
    "previewObject": {
      "selectUser": "Clientes",
      "selectGoal": "Metas",
      "selectAccount": "Cuentas",
      "selectSubAccount": "Subcuentas",
      "selectScheduleTransfer": "Programar transferencias",
      "selectClientGroup": "Grupos de clientes",
      "selectTitle": "Seleccione un {{objectType}} para previsualizarlo"
    }
  },
  "localizationModal": {
    "createTitle": "Crear nueva localización",
    "editTitle": "Editar localización",
    "name": "Nombre",
    "nameHelper": "Nombre legible de la configuración de localización a continuación",
    "countries": "País(es) aplicable(s)",
    "countriesHelper": "Uno o más países en los que se atiende a los clientes de una organización",
    "defaultCurrency": "Moneda base",
    "defaultCurrencyHelper": "Moneda predeterminada (base) utilizada en los informes",
    "languages": "Idiomas de la interfaz de usuario",
    "defaultLanguage": "Idioma predeterminado",
    "dateFormat": "Formato de la fecha",
    "dateFormatHelper1": "Siga ",
    "dateFormatHelper2": "cadena de formato para los días",
    "datePreview": "Vista previa de la fecha",
    "firstDay": "1er. día de este mes",
    "today": "hoy",
    "lastDay": "último día de este mes",
    "phoneNumberCountryCodes": "Códigos de país para números de teléfono",
    "phoneNumberCountryCodesHelper": "Cuando la lista de códigos de país está vacía, se utilizarán los países aplicables como valor predeterminado",
    "languageChangeWarning": "Los cambios en la configuración de idioma se aplicarán a todos los usuarios."
  },
  "changeOrganization": "Cambiar organización",
  "ORGANIZATION": "Acceso organizacional",
  "REP_CODE": "Acceso al código de representante",
  "ENTITY": "Acceso a la entidad",
  "exchangeRatesConfiguration": {
    "title": "Configuración de tipos de cambio",
    "manualUpdate": "Actualización manual",
    "autoUpdate": "Actualizar automáticamente",
    "fromTo": "De {{from}} a {{to}}",
    "rateError": "La tarifa debe ser superior a 0"
  },
  "bulkTradingProcessOptions": {
    "pair": "EMPAREJAR",
    "bucket": "CATEGORÍA"
  },
  "configurableTablePages": {
    "archiveConfigurableTablePageModal": {
      "title": "¿Archivar {{configurableTablePageName}}?",
      "bodyText": "Esta página de tabla configurable se archivará. ¿Desea continuar?"
    },
    "title": "Páginas de tabla configurables",
    "inheritFromParent": "Heredar páginas de tabla configurables de la organización principal",
    "description": "Las páginas de tablas configurables le permiten crear tablas personalizadas que se pueden utilizar para mostrar datos de su organización. Puede configurar los filtros, las columnas y la paginación según sus necesidades.",
    "table": {
      "name": "Nombre",
      "sectionName": "Nombre de la sección",
      "organization": "Organización"
    },
    "noData": "No se han encontrado páginas de tabla configurables",
    "errorLoading": "Error al cargar la página de la tabla configurable",
    "createSuccess": "Página de tabla configurable creada correctamente",
    "updateSuccess": "Página de tabla configurable actualizada correctamente",
    "requiredFiltersMessage": "Configure los filtros necesarios para ver los datos: {{filtersNames}}",
    "noSearchResults": "No se encontraron resultados que coincidan con los criterios de búsqueda",
    "searchResultsWillAppearHere": "Los resultados de la búsqueda aparecerán aquí",
    "errorLoadingData": "Error al cargar los datos",
    "loading": "Cargando…",
    "export": {
      "title": "Exportar información",
      "generating": "Generando archivo de exportación…",
      "completed": "Exportación completada con éxito",
      "failed": "Error al exportar",
      "download": "Descargar"
    },
    "searchFilters": {
      "title": "OPCIONES DE BÚSQUEDA",
      "search": "Buscar",
      "reset": "Restablecer"
    },
    "modal": {
      "title": "Crear página de tabla configurable",
      "editTitle": "Editar página de tabla configurable",
      "settings": {
        "title": "Configuración",
        "name": "Nombre",
        "sectionName": "Nombre de la sección",
        "sectionIcon": "Ícono de la sección",
        "navigateToPath": "Navegar a la ruta",
        "navigateToPathNone": "Ninguno",
        "navigateToPathKey": "Navegar a la ruta clave",
        "endpointUrl": "URL del punto final",
        "paginationType": "Tipo de paginación",
        "enableDownload": "Habilitar descarga",
        "useTopSearchPanel": "Utilizar el panel de búsqueda superior",
        "navigateToPathError": "Es necesario seleccionar Navegar a ruta cuando se proporciona la clave para Navegar a la ruta",
        "navigateToPathKeyError": "Es necesario seleccionar Navegar a ruta clave cuando se proporciona la clave para Navegar a la ruta",
        "enableCustomPagination": "Personalizar opciones de paginación",
        "customPageSizes": "Opciones de tamaño de página (separadas por comas)",
        "customPageSizesError": "Las opciones de tamaño de página son obligatorias cuando la personalización de paginación está activada",
        "customPageSizesPlaceholder": "ej. 10, 25, 50, 100"
      },
      "filters": {
        "title": "Filtros",
        "filterOptions": "Opciones de filtro",
        "name": "Nombre",
        "key": "Clave",
        "type": "Tipo",
        "format": "Formato",
        "required": "Obligatorio",
        "isTopLevelFilter": "Es un filtro de nivel superior",
        "additionalInfo": "Información adicional",
        "default": "Predeterminado",
        "types": {
          "TEXT": "Texto",
          "SINGLE_SELECT": "Selección única",
          "MULTIPLE_SELECT": "Selección múltiple",
          "DATE": "Fecha",
          "BOOLEAN": "Booleano",
          "INTEGER": "Número entero",
          "DECIMAL": "Decimal"
        },
        "formats": {
          "TOGGLE_SWITCH": "Botón para activar y desactivar",
          "CHECKBOX": "Casilla",
          "RADIO_BUTTON": "Botón de opción",
          "DROPDOWN_LIST": "Lista desplegable",
          "NUMBER": "Número",
          "CURRENCY": "Moneda",
          "DATE": "Fecha",
          "DATE_TIME": "Fecha y hora",
          "SIMPLE_TEXT": "Texto sencillo"
        },
        "options": {
          "title": "Opciones",
          "optionsType": "Tipo de opciones",
          "staticOptions": "Opciones estáticas",
          "optionsUrl": "Opciones de URL"
        },
        "staticOptionsKey": "Clave",
        "staticOptionsLabel": "Etiqueta",
        "addStaticOption": "Agregar opción estática",
        "addFilter": "Agregar filtro",
        "updateFilter": "Actualizar filtro"
      },
      "columns": {
        "title": "Columnas",
        "columnOptions": "Opciones de columna",
        "name": "Nombre",
        "key": "Clave",
        "type": "Tipo",
        "formatter": "Formateador",
        "badgeColorKey": "Clave de colores de las insignias",
        "additionalInfo": "Información adicional",
        "sortable": "Clasificable",
        "types": {
          "DATE": "Fecha",
          "TEXT": "Texto",
          "CURRENCY": "Moneda",
          "NUMBER": "Número",
          "BADGE": "Insignia",
          "PERCENTAGE": "Porcentaje"
        },
        "formatters": {
          "SIMPLE_TEXT": "Texto simple",
          "TRANSLATED_TEXT": "Texto traducido",
          "CAPITALIZED_TEXT": "Texto con mayúsculas",
          "DATE": "Fecha",
          "DATE_TIME": "Fecha y hora",
          "MULTIPLY_BY_100": "Multiplicar por 100",
          "DIVIDE_BY_100": "Dividir entre 100"
        },
        "addColumn": "Agregar columna",
        "updateColumn": "Actualizar columna",
        "badgeMapping": {
          "title": "Mapeo de insignias",
          "value": "Valor",
          "color": "Color",
          "addMapping": "Añadir mapeo"
        },
        "includeInTotals": "Incluir en los totales",
        "rowScope": "Alcance de la fila",
        "rowScopes": {
          "MAIN": "Principal",
          "COLLAPSIBLE": "Plegable"
        }
      },
      "widgets": {
        "addWidget": "Añadir widget",
        "updateWidget": "Actualizar widget",
        "widgetType": "Tipo de widget",
        "options": "Opciones",
        "types": {
          "FREE_FORM_INPUT": "HTML de formato libre"
        },
        "title": "Componentes"
      }
    },
    "paths": {
      "ACCOUNTS": "Cuentas",
      "INDIVIDUALS": "Personas físicas",
      "NON_INDIVIDUALS": "Personas no físicas",
      "HOUSEHOLDS": "Hogares",
      "GOALS": "Metas",
      "SUB_ACCOUNTS": "Subcuentas",
      "ACCOUNT_GROUPS": "Grupos de cuentas"
    },
    "paginationType": {
      "OFFSET": "Compensación",
      "CURSOR": "Cursor"
    },
    "total": "Total",
    "noDataAvailable": "No hay registros disponibles para mostrar",
    "editor": {
      "preview": "Previsualizar",
      "saveToSearch": "Guarde sus cambios para buscar y cargar los datos de previsualización."
    },
    "expandRow": "Expandir fila",
    "collapseRow": "Contraer fila"
  },
  "permissionLabels": {
    "drift_settings": "Configuración de Desviación",
    "account": "Cuentas y Carteras",
    "account_fee": "Tarifas de Gestión de Cuentas",
    "account_number": "Números de Cuenta del Custodio",
    "account_statement": "Estados de Cuenta",
    "account_statements": "Generación de Estados de Cuenta",
    "adjustment_transaction": "Transacciones de Ajuste",
    "adjustment_transfer": "Transferencias de Ajuste",
    "advanced_organization_settings": "Configuración Avanzada de la Organización",
    "affiliate_conversion": "Conversión de Usuarios Afiliados",
    "alert_banners": "Banners de Alerta del Portal",
    "alert_report": "Informes de Transacciones Sospechosas",
    "all_themes": "Todas las Familias de Modelos (No Solo Sugeridas)",
    "api_exports": "Exportaciones de Datos CSV",
    "api_token_jwt": "Token JWT de API",
    "api_tokens": "Tokens de API",
    "archived_bank_accounts": "Cuentas Bancarias del Cliente (Archivadas)",
    "asset_classes": "Clases de Activos",
    "audit_logs": "Registros de Auditoría",
    "bank_account": "Cuentas Bancarias del Cliente",
    "bank_account_disclosed": "Números de Tránsito Bancario y de Cuenta (Sin Enmascarar)",
    "beneficiary": "Beneficiarios de la Cuenta",
    "beneficiary_pii": "PII del Beneficiario",
    "billing_cycle": "Ciclos de Facturación",
    "billing_fee": "Tarifas Facturadas",
    "billing_schedule": "Calendarios de Facturación",
    "bulk_import": "Importaciones Masivas",
    "bulk_trade_request": "Solicitudes de Negociación Masiva",
    "bulk_trade_run": "Ejecuciones de Negociación Masiva",
    "bulk_upsert_request": "Solicitudes de Upsert Masivo",
    "cash_and_holdings": "Estadísticas de Efectivo y Tenencias",
    "client": "Información Básica del Cliente",
    "client_authentication": "Configuración de Autenticación del Cliente",
    "client_billing": "Configuración de Facturación del Cliente",
    "client_bulk_account_opening": "Apertura Masiva de Cuentas de Clientes",
    "client_group": "Grupos de Clientes",
    "client_high_risk_pii": "PII del Cliente (Alto Riesgo)",
    "client_low_risk_pii": "PII del Cliente (Bajo Riesgo)",
    "client_suitability": "Idoneidad del Cliente",
    "client_taxid_disclosed": "Identificaciones Fiscales del Cliente (Sin Enmascarar)",
    "configurable_table_data": "Datos de Tabla Configurables",
    "configurable_table_page": "Páginas de Tabla Configurables",
    "configurable_table_page_export": "Exportaciones de Páginas de Tabla Configurables",
    "corporate_account": "Cuentas Corporativas",
    "custodian_activity": "Actividades del Custodio",
    "custodian_connection": "Conexiones del Custodio",
    "custodian_connection_config": "Credenciales de Conexión del Custodio",
    "custom_fields": "Campos Personalizados",
    "daily_fee": "Cálculos de Tarifas Diarias",
    "dashboards": "Paneles de Control",
    "event": "Eventos del Cliente",
    "external_client_secrets": "Secretos de Cliente Externo de Usuario de la Organización",
    "external_transfer": "Transferencias Externas",
    "external_vendor_usage": "Uso de Proveedores Externos",
    "feature_flags": "Indicadores de Características de la Organización",
    "fee_setting": "Configuración de Tarifas",
    "fee_tier": "Niveles de Tarifas",
    "files": "Documentos de Cliente y Cuenta",
    "financial_product_org_history": "Historial de Cantidad y Valor de Productos Financieros",
    "financial_products": "Productos Financieros (Estante de Productos)",
    "financial_products_snapshots": "Historial de Precios de Productos Financieros",
    "flags": "Indicadores Operacionales",
    "force_account_open": "Forzar Apertura de Cuenta",
    "foreign_exchange_rate": "Tasas de Cambio (Últimas)",
    "foreign_exchange_snapshots": "Tasas de Cambio (Instantáneas Diarias)",
    "form_agreement": "Acuerdos de Formulario del Cliente",
    "form_completion": "Completados de Formulario",
    "form_definition": "Definiciones de Formulario",
    "form_map_resolution": "Resolución de Mapa de Formulario",
    "form_template": "Plantillas de Formulario",
    "fraud_risk": "Riesgo de Fraude del Cliente",
    "full_tax_disclosed": "Números Fiscales del Grupo de Clientes (Sin Enmascarar)",
    "goal": "Metas",
    "history": "Instantáneas del Historial",
    "id_verification": "Verificación de Identificación",
    "institution": "Instituciones Financieras",
    "integration_request_payload": "Cargas Útiles de Solicitud de Integración",
    "integrations": "Integraciones",
    "integrations_config": "Integraciones (Configuración Completa)",
    "invite_organization_users": "Invitar Usuarios de la Organización",
    "localizations": "Configuración de Localización",
    "manual_process": "Procesos Manuales",
    "manually_add_bank_account": "Cuentas Bancarias del Cliente (Añadidas Manualmente)",
    "manually_upload_form_agreement": "Acuerdos de Formulario del Cliente (Carga Manual)",
    "model_change_proposals": "Propuestas de Cambio de Modelo",
    "model_portfolios": "Carteras Modelo",
    "news_and_insights": "Noticias y Perspectivas",
    "notes": "Notas",
    "notification": "Notificaciones",
    "notification_definition": "Definiciones de Notificación",
    "notification_group": "Grupos de Notificación",
    "organization_files": "Documentos de la Organización",
    "organization_settings": "Configuración de la Organización",
    "organization_user_authentication": "Configuración de Autenticación de Usuarios de la Organización",
    "organization_user_entities": "Asociaciones de Entidades de Usuarios de la Organización",
    "organization_user_profile": "Perfil de Usuario de la Organización (Propio)",
    "organization_users": "Usuarios de la Organización",
    "organizations": "Organizaciones",
    "override_transfer_restrictions": "Anular Restricciones de Transferencia",
    "page_configurations": "Configuraciones de Página",
    "portfolio_optimizer": "Optimizadores de Cartera",
    "portfolio_templates": "Plantillas de Cartera",
    "re_generate_pdf": "Regenerar Documentos de Formulario",
    "rebalance": "Reequilibrios",
    "recon_jobs": "Trabajos de Reconciliación",
    "reconcile_canceled_transfer": "Reconciliar Transferencias Canceladas",
    "registered_adjustment_transfer": "Transferencias de Ajuste de Cuentas Registradas",
    "rep_code": "Códigos de Representante",
    "reports": "Informes (Incluye PII)",
    "retry_failed_webhooks": "Reintentar Webhooks Fallidos",
    "role_profiles": "Perfiles de Roles",
    "rule": "Reglas de Transacciones Sospechosas",
    "sales_tax_configuration": "Configuración de Impuestos sobre Ventas",
    "schedules": "Calendarios de Negociación",
    "signer_type": "Tipos de Firmantes",
    "sub_account_billing": "Facturación de Subcuentas",
    "sub_trade_request": "Solicitudes de Subcomercio",
    "sub_trade_request_verification": "Verificación de Solicitudes de Subcomercio",
    "subAccount_liquidation": "Liquidación de Subcuentas",
    "themes": "Familias de Modelos (Temas)",
    "trade": "Operaciones",
    "trade_request": "Solicitudes de Operaciones",
    "transaction": "Transacciones",
    "transfer": "Transferencias",
    "transfer_account_number_disclosed": "Números de Cuenta de Transferencia (Sin Enmascarar)",
    "transfer_obo_clients": "Transferencias en Nombre de Clientes",
    "upsert_bulk_trade_run_allocation_files": "Archivos de Asignación de Ejecución de Operaciones Masivas",
    "upsert_bulk_trade_run_bulk_trade_files": "Archivos de Operaciones de Ejecución de Operaciones Masivas",
    "withdraw_fees": "Estimaciones de Tarifas de Retiro",
    "workflow": "Flujos de Trabajo",
    "workflow_completion": "Finalizaciones de Flujos de Trabajo",
    "roles": "Roles",
    "siem_feed_jwt": "JWT de fuente SIEM",
    "siem_feeds": "Fuentes SIEM",
    "webhook": "Webhooks"
  },
  "update": "Actualizar",
  "a11y": {
    "moreActions": "Más acciones"
  },
  "dashboardArchiveModal": {
    "title": "¿Archivar panel de control?",
    "body": "Este panel de control se archivará y ya no aparecerá en las listas de paneles de control activos.",
    "confirm": "Archivar"
  },
  "successArchiveDashboard": "Panel de control archivado correctamente",
  "permissionTooltip": {
    "about": "Acerca de {{label}}",
    "actions": {
      "read": "Leer:",
      "write": "Escribir:",
      "transition": "Transición:"
    }
  }
}
